<template>
    <div class="uik-toggleText">
        <input
            id="uik-toggleText"
            :value="value"
            type="checkbox"
            @change="$emit('change', !value)">
        <label for="uik-toggleText">{{text}}</label>
    </div>
</template>

<script>
export default {
    name: "UikToggleText",
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        text: { type: String, default: "Label" },
        value: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-toggleText {
    input {
        display: none;
    }
    label {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        padding: 13px 6px;
        text-align: center;
        color: $textMain;
        transition: all 0.15s;
        background: transparent;
        border-bottom: solid 2px transparent;
        &:hover {
            cursor: pointer;
        }
    }
    input:checked + label {
        color: $primary;
        border-color: $primary;
    }
}
</style>
